import { Injectable } from '@angular/core';
import { Pallet } from '../interfaces/pallet';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PalletCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/pallets/current/';
  }

  getOrganisation() : string | null {
    const company = JSON.parse(localStorage.getItem('organisation')!);
    if (company && typeof company.$key !== 'undefined') {
        return company.$key;
    }
    return null;
  }

  // Create Pallet
  add(record: Pallet) {
    const org = this.getOrganisation();
    if (!org) {
      return;
    } 
    this.refs = this.db.list('organisations/' +  org + '/' + this.path );
    const item = {
      ...record
    }
    const newItem = this.refs?.push( item );
    const key = newItem.key;
    item.key = key || 'na';
    item.$key = key || 'na';
    this.update(item);
  }
  // Fetch Single Pallet Object
  get(id: string) {
    const org = this.getOrganisation();
    if (!org) {
      return {} as AngularFireObject<any>;
    }  
    this.ref = this.db.object( 'organisations/' + org + '/' + this.path + id);
    return this.ref;
  }
  // Fetch Parcels List
  getList() {
    const org = this.getOrganisation();
    if (!org) {
      return {} as AngularFireList<any>;
    } 
    this.refs = this.db.list( 'organisations/' + org + '/' + this.path );
    return this.refs;
  }
  // Update Parcel Object
  update(record: Pallet) {
    const org = this.getOrganisation();
    if (!org) {
      return;
    } 
    this.ref = this.db.object( 'organisations/' + org + '/' + this.path + record.$key);
    let item : Partial<Pallet>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Parcel Object
  delete(id: string) {
    const org = this.getOrganisation();
    if (!org) {
      return;
    } 
    this.ref = this.db.object( 'organisations/' + org + '/' + this.path + id);
    this.ref.remove();
  }
}
